<template>
  <!-- ссылка получена — тот же блок, что у одиночного видео -->
  <ItemResultDefault
    v-if="video"
    ref="result"
    :item="video"
    :event-label="eventLabel"
  />

  <!-- до получения ссылки — разметка ItemResultDefault, вместо форматов кнопка «Dapatkan tautan» -->
  <div v-else class="result-box video playlist-item">
    <div class="thumb-box thumb-272">
      <div class="clip">
        <img
          v-if="item.thumb"
          :src="item.thumb"
          class="thumb"
          :alt="title"
          loading="lazy"
          @error="$event.target.remove()"
        />
        <span class="play-btn"></span>
      </div>
    </div>

    <div class="info-box">
      <div class="meta">
        <div class="row title" :title="title">{{ title }}</div>
        <div v-if="item.meta?.duration" class="row duration">{{ item.meta.duration }}</div>
      </div>

      <div class="link-box">
        <p v-if="failed" class="playlist-item__error" role="alert">Gagal mendapatkan tautan unduhan.</p>
        <div class="def-btn-box">
          <button
            type="button"
            class="playlist-item__get-link"
            :disabled="loading"
            :aria-busy="loading ? 'true' : 'false'"
            @click="getLink"
          >
            <span v-if="loading" class="playlist-item__spinner" aria-hidden="true"></span>
            <template v-else>{{ failed ? 'Coba lagi' : 'Dapatkan tautan' }}</template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../api/Api'
import analytics from '../tools/ga'
import { expBus } from '@js-packages/experiment-loader'
import ItemResultDefault from './ItemResultDefault.vue'
import { realFormats } from '../tools/playlist'
import { getBetterQualities } from '../tools/betterQualities'
import { playlistPayload } from '../tools/playlistExperimentContract'

// request_failed label, когда ссылку видео плейлиста получить не удалось
const LINK_ERROR_TYPE = 'playlist_link_error'

// Видео YouTube-плейлиста — блок одиночной выдачи (ItemResultDefault.vue) в списке друг за другом.
// Элементы плейлиста приходят заглушками url: [{}] — ссылку видео блок запрашивает сам по клику
// «Dapatkan tautan» (отдельный /api/convert по meta.source), как в savefrom.net (PlaylistElement.jsx);
// после загрузки — тот же выбор качества и «Unduh», что у одиночного видео.
export default {
  name: 'PlaylistCard',
  components: { ItemResultDefault },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // ссылки пришли уже в ответе плейлиста — кнопка не нужна
      video: realFormats(this.item.url).length ? this.item : null,
      loading: false,
      failed: false,
      // event_label события download_click из блока плейлиста
      eventLabel: 'playlist'
    }
  },
  computed: {
    title() {
      return this.item.meta?.title || ''
    },
    source() {
      return this.item.meta?.source
    }
  },
  methods: {
    async getLink() {
      if (this.loading) return
      analytics.playlistGetLinkClick(this.source)
      this.failed = false
      this.loading = true
      try {
        const res = await Api.requestToLink({
          url: this.source,
          subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody
        })
        const obj = Array.isArray(res.data) ? res.data[0] : res.data
        if (res.data?.success === false || !obj || !realFormats(obj.url).length) {
          this.fail()
          return
        }
        // обложка и название — из элемента плейлиста, чтобы блок не «прыгал» после загрузки
        this.video = {
          ...obj,
          thumb: this.item.thumb || obj.thumb,
          url: obj.url.filter((f) => f && typeof f.url === 'string' && f.url.length > 0),
          meta: { ...obj.meta, title: this.title || obj.meta?.title, duration: obj.meta?.duration || this.item.meta?.duration }
        }
        this.emitBestQuality()
      } catch (e) {
        this.fail()
      } finally {
        this.loading = false
      }
    },

    fail() {
      this.failed = true
      analytics.showError(this.source, LINK_ERROR_TYPE)
    },

    // tzPlatformLinks: как у одиночного видео (ResultDefault), но в .link-box этого блока —
    // только когда ссылка получена и форматы уже в DOM. Payload — по контракту
    // tools/playlistExperimentContract.js (kind: 'playlist', list).
    emitBestQuality() {
      this.$nextTick(() => {
        const better = getBetterQualities(this.video)
        const linkBox = this.$refs.result?.$refs.dropdown
        if (better && linkBox) {
          expBus.emit('tzBestQuality', playlistPayload(better, linkBox))
        }
      })
    }
  }
}
</script>
